import { Link } from 'react-router-dom';
import Logo from './Logo';
import Icon from './Icon';
import CompanyAddress from './CompanyAddress';
import {
  BRAND,
  COMPANY_NAME,
  FOOTER_DISCLAIMER,
  SITE_DOMAIN,
  SITE_NAME,
  SUPPORT_EMAIL,
  SUPPORT_HOURS,
  SUPPORT_PHONE,
  SUPPORT_PHONE_TEL,
} from '../constants/site';

const shopLinks = [
  { to: '/#plans', label: 'Pricing Plans' },
  { to: '/#products', label: 'All Products' },
  { to: '/#compare', label: 'Compare Plans' },
  { to: '/#features', label: 'Security Features' },
];

const helpLinks = [
  { to: '/contact', label: 'Contact Support' },
  { to: '/#faq', label: 'FAQ' },
  { to: '/#reviews', label: 'Customer Reviews' },
  { to: '/#insights', label: 'Security Insights' },
];

const legalLinks = [
  { to: '/privacy-policy', label: 'Privacy Policy' },
  { to: '/terms-of-service', label: 'Terms of Service' },
  { to: '/refund-policy', label: 'Refund Policy' },
  { to: '/disclaimer', label: 'Disclaimer' },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__grid">
          <div>
            <Logo light />
            <p className="footer__about">
              {SITE_NAME} is an independent reseller and technical support desk for {BRAND} security
              software. We supply genuine licences, handle installation end to end, and stay on the
              line until your devices are protected.
            </p>
            <div className="footer__contact">
              <a href={`tel:${SUPPORT_PHONE_TEL}`}>
                <Icon name="phone" size={17} />
                {SUPPORT_PHONE}
              </a>
              <a href={`mailto:${SUPPORT_EMAIL}`}>
                <Icon name="mail" size={17} />
                {SUPPORT_EMAIL}
              </a>
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>
                <Icon name="clock" size={17} />
                {SUPPORT_HOURS}
              </span>
              <span
                style={{ display: 'inline-flex', alignItems: 'flex-start', gap: 10, marginTop: 4 }}
              >
                <Icon name="shield" size={17} />
                <CompanyAddress />
              </span>
            </div>
          </div>

          <div>
            <h3 className="footer__title">Shop</h3>
            <div className="footer__links">
              {shopLinks.map((l) => (
                <Link key={l.label} to={l.to}>
                  {l.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h3 className="footer__title">Help</h3>
            <div className="footer__links">
              {helpLinks.map((l) => (
                <Link key={l.label} to={l.to}>
                  {l.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h3 className="footer__title">Legal</h3>
            <div className="footer__links">
              {legalLinks.map((l) => (
                <Link key={l.label} to={l.to}>
                  {l.label}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <p>
            © {year} {SITE_NAME} · {SITE_DOMAIN}. Operated by {COMPANY_NAME}. All rights reserved.
          </p>
          <div className="footer__legal">
            {legalLinks.map((l) => (
              <Link key={l.label} to={l.to}>
                {l.label}
              </Link>
            ))}
          </div>
        </div>

        <div className="footer__disclaimer">
          <p className="footer__disclaimer-head">Disclaimer</p>
          {FOOTER_DISCLAIMER.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </div>
      </div>
    </footer>
  );
}
